import React from 'react';
import Contact from '../components/sections/Contact';
import { motion } from 'framer-motion';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background-alt">
      <div className="w-full bg-gradient-to-br from-primary/90 to-secondary/90 text-primary py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-primary">
            Contact ReasonShield
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto opacity-90">
            Have questions about our lab results processing platform? Reach out to our team of clinical experts.
          </p>
        </motion.div>
      </div>

      <div className="-mt-6">
        <Contact />
      </div>
      
     
    </div>
  );
};

export default ContactPage; 